import _ from 'lodash'
import module from './module'
import api from '../services/api'
import crudMixin from '@/core/store/mixin/crud'

const res = _.merge({},
  crudMixin(api),
  module,
)

export default res
